import { createSlice } from '@reduxjs/toolkit';

export const defaultCoordinates = {
  // Default loaction is Head Office at 600-500 Lakeshore Blvd
  lat: 43.637468,
  lng: -79.397889,
};
const initialState = {
  showKioskSetup: false,
  storeCategories: [],
  stores: [],
  nearbyTmsStores: {},
  locationCoordinates: defaultCoordinates,
};

const sharedSlice = createSlice({
  name: 'Shared',
  initialState,
  reducers: {
    updateShowKioskSetup: (state, action) => {
      state.showKioskSetup = action.payload;
    },
    updateStoreCategories: (state, action) => {
      state.storeCategories = action.payload;
    },
    updateStores: (state, action) => {
      state.stores = action.payload;
    },
    updateNearbyTmsStores: (state, action) => {
      const lclId = action.payload.commonInfo.lclId.replace(/-TMS$/, '');
      state.nearbyTmsStores = {
        ...state.nearbyTmsStores,
        [lclId]: action.payload,
      };
    },
    resetNearbyTmsStores: (state) => {
      state.nearbyTmsStores = {};
    },
    resetLocationCoordinates: (state) => {
      state.locationCoordinates = defaultCoordinates;
    },
    updateLocationCoordinates: (state, action) => {
      state.locationCoordinates = action.payload;
    },
  },
});

export const {
  updateStoreCategories,
  updateStores,
  updateNearbyTmsStores,
  resetNearbyTmsStores,
  updateLocationCoordinates,
  resetLocationCoordinates,
  updateShowKioskSetup,
} = sharedSlice.actions;

export default sharedSlice.reducer;
